module.exports = __webpack_public_path__ + "media/images/front/icon_new-window-90dd23352b7cb52f9c71b46f927c2568.png";